import React from "react";
import { useTranslation } from "../../context";
import CreateMenu from "../../components/CreateMenu";
import { isFocusEnv } from "@/utils";
import { openLowCode } from "@/components/Joyspace/util";

export default function () {
  const lang = useTranslation();

  React.useEffect(() => {}, [lang]);

  return (
    <CreateMenu
      // team={team}
      // space={space}
      canCreateFolder={false}
      lowCode={isFocusEnv() ? openLowCode : undefined}
      from="HOME"
    />
  );
}
